export default "__VITE_ASSET__d78a3922__"